import axios from 'axios';
import { message } from 'antd';
import { SYNC_ORDER_TO_DB } from '../actions/types';

import { URL_ENDPOINT } from '../../../index';

export const syncOrderToDb = store => next => action => {

	if(action.type === SYNC_ORDER_TO_DB){

		const order = store.getState().activeOrder;
		// const { productId } = action;

		// const product = order.data.products.filter( product => product._id === productId)[0];

		// message.loading('syncing');

		axios({
			url: `${URL_ENDPOINT}/api/admin/orders/${order.data._id}`,
			method:'put',
			withCredentials: true,
			data: { 
				order: order.data,
				param: action.PARAM
			}
		}).then(
			res => {
				message.destroy();
			}
		)

	}

	return next(action);
}



// WEBPACK FOOTER //
// ./src/components/orders/middlewares/index.js